import { IDefaultElement, buildCustomExpressionValue } from "core";
import { UntransformedBoolFieldConfig } from "../types";

export const defaultElement: IDefaultElement<UntransformedBoolFieldConfig> = {
  config: {
    value: buildCustomExpressionValue("true"),
  },
};
